const LAN_ORIGIN_PATTERN = /^https?:\/\/192\.168\.1[\d.:]*/i

/** Keep in-page hrefs path-only so dev LAN origins never appear in link targets. */
export function stripLanAbsoluteLinks(root: ParentNode = document): void {
  if (typeof document === 'undefined') return

  root.querySelectorAll('a[href]').forEach((node) => {
    if (!(node instanceof HTMLAnchorElement)) return
    const href = node.getAttribute('href') ?? ''
    if (!LAN_ORIGIN_PATTERN.test(href)) return
    try {
      const url = new URL(href)
      node.setAttribute('href', `${url.pathname}${url.search}${url.hash}`)
    } catch {
      // ignore malformed URLs
    }
  })

  document.querySelectorAll('link[rel="prefetch"][href*="192.168.1"]').forEach((node) => {
    node.remove()
  })
}
